import React from 'react';
import classnames from 'classnames/bind';
import { UploadOutlinedIcon } from 'tuui';
import { useDragAndDropFileContext } from 'taboola-ultimate-ui';
import styles from 'modules/campaigns/modules/creative-editor/components/MediaTabs/MediaLibraryTab/uploadGalleryItem.module.scss';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

const classNameBuilder = classnames.bind(styles);

export const MediaDragAndDropContent = ({ itemHeight, containerClassName }) => {
    const { openFileDialog } = useDragAndDropFileContext();
    return (
        <div className={classNameBuilder(styles['container'], containerClassName)} style={{ height: itemHeight }}>
            <UploadOutlinedIcon className={styles['upload-icon']} />
            <div className={styles['title']}>
                <FormattedMessage id="creative.editor.tab.mediaLibrary.upload.item.title" defaultMessage="Upload" />
            </div>
            <div className={styles['subtitle']}>
                <FormattedMessage
                    id="creative.editor.tab.mediaLibrary.upload.item.description"
                    defaultMessage="or drag and drop files here"
                />
            </div>
            <div className={styles['open-dialogue-container']} onClick={openFileDialog} />
        </div>
    );
};
